import React, { useState } from "react";
import ModalContact from "../pages/FO/AideContact/ModalContact";

interface IProps {
  description1?: React.ReactNode;
  description2?: React.ReactNode;
  img_rond?: string;
  linktext: string;
  contactsujet:number;
}


const CpntBlocPresentationDetail: React.FC<IProps> = ({description1,description2, img_rond,linktext,contactsujet }) => {

  const [showModal, setModal] = useState(false);
  
  return (
    <>
    <div className="row align-items-center">
      <div className={`text-md-end col-lg-2 offset-lg-2 col-md-3 offset-md-2 col-sm-12 "}`}>
      { <img src={img_rond} alt="" className="img-fluid img-rond" />}
      </div>
      <div className={`col-lg-6 offset-lg-0 col-md-5 offset-md-0 col-sm-10 offset-sm-1 mt-4 mt-md-0 d-flex justify-content-md-start ps-3`}>
        <div className="text-start">
          <div>{description1}</div>
        </div>
      </div>
      <div className={`col-md-8 offset-md-2 col-sm-10 offset-sm-1 mt-4 d-flex justify-content-md-start`}>
        <div className="text-start">
          <div>{description2}</div>
        </div>
      </div>
    </div>
    <div className="text-center mt-4 mb-4">
        {/* <Link className="btn btn-secondary" 
         to={linkpath} 
         target={linkblank ? '_blank' : undefined} // target="_blank" si besoin
        >
          {linktext}
        </Link> */}
        <button className="btn btn-secondary" 
                    onClick={() => {
                      setModal(true);
                }}>{linktext}</button>
        <ModalContact
        idDefaultSujet={contactsujet}
        show={showModal}
        onHide={() => setModal(false)}
        />
      </div>
    </>
  );
};

export default CpntBlocPresentationDetail;


